import { render } from "./customer_own_profile.vue?vue&type=template&id=23b2fb82&scoped=true"
import script from "./customer_own_profile.vue?vue&type=script&lang=js"
export * from "./customer_own_profile.vue?vue&type=script&lang=js"

import "./customer_own_profile.vue?vue&type=style&index=0&id=23b2fb82&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b2fb82"]])

export default __exports__